import { useCallback } from 'react';
import { getConnectionsService, sharingCodeValidateService } from 'Services/libre_api';
const useLibreConnection = () => {
  const getConnections = useCallback(async () => {
    const connections = await getConnectionsService();
    return connections;
  }, []);
  const sharingCodeValidate = useCallback(async (code, yearOfBirth) => {
    await sharingCodeValidateService({
      code,
      yearOfBirth
    });
  }, []);
  return {
    getConnections,
    sharingCodeValidate
  };
};
export default useLibreConnection;